import { checkIfEmailIsVerifiedOrNot, useUserContext } from '../contexts/UserContext';
import { successToast, warningToast } from '../helpers/toastHelper';

import { EMAIL_VERIFIED } from '../constants/projectConstants';
import { LogCurator } from '../helpers/logEvents';
import { apiPostResendOtpEmail } from '../helpers/api';
import { setLocalStorage, textLowerCaseAndTrim } from '../helpers/jsHelper';
import { selectIsChatBotAvailable } from '../redux/slicers/activitySlicer';
import { useSelector } from 'react-redux';

export const useVerifyEmail = () => {
  const { currentUser, setEmailVerified } = useUserContext();

  const handleResend = (e = null) => {
    const email = currentUser?.user?.email;

    e?.preventDefault();
    if (email === null) {
      warningToast('Email is not valid!');
      return;
    }
    const formData = new FormData();
    formData.append('email', textLowerCaseAndTrim(email));
    apiPostResendOtpEmail(formData)
      .then((res) => {
        if (res) {
          let { status, data, message } = res;
          if (status === true) {
            successToast(message);
          }
        }
      })
      .catch((error) => {
        if (!error?.status && error?.message?.toLowerCase()?.includes('already verified')) {
          setEmailVerified(true);
          setLocalStorage(EMAIL_VERIFIED, true);
        }
        LogCurator('DEBUG_LOG error', error);
      });
  };

  return {
    handleResend,
  };
};

export const VerifyYourEmail = ({ fullWidth = false }) => {
  const isChatBotAvailable = useSelector(selectIsChatBotAvailable);
  const { currentUser, emailVerified } = useUserContext();

  const { handleResend } = useVerifyEmail();

  if (!currentUser) return null;
  if (checkIfEmailIsVerifiedOrNot(false) || emailVerified) return null;

  const params = new URLSearchParams(window.location.search);
  const isOnboarding = params.get('isOnboarding');

  return (
    <div
      className="d-flex justify-content-between align-items-center flex-wrap gap-1 footer-line"
      style={{
        position: 'fixed',
        left: '0',
        bottom: '0',
        padding: '0.75rem',
        backgroundColor: '#FCEAE8',
        zIndex: isChatBotAvailable ? 100 : 1000,
        ...(fullWidth || isOnboarding === 'true'
          ? {
              margin: 0,
              width: '100%',
            }
          : {
              marginLeft: '232px',
              width: 'calc(100% - 232px)',
            }),
      }}>
      <div className="footer-wrapper">
        <h2 className="footer-heading-email-varification">Email not verified!</h2>
        <p className="footer-text-email-varification">
          Please verify your email id to unlock all features.{' '}
          {/* <div className="d-flex align-items-center gap-2"> */}
          <a className="lf-link text-decoration-none cursorPointer" onClick={handleResend}>
            Resend email
          </a>
          {/* </div> */}
        </p>
      </div>
    </div>
  );
};
